import request from '@/utils/request'

// 登录用户话题信息
export function getUserInfo (userId) {
  return request({
    url: `/topic/user/${userId}`,
    method: 'get'
  })
}

// 分区列表
export function getZone () {
  return request({
    url: '/topic/category/list',
    method: 'get'
  })
}

// 获取详情
export function getDetail (topicId) {
  return request({
    url: `/topic/detail/${topicId}`,
    method: 'get'
  })
}

// 热门信息
export function getHot () {
  return request({
    url: '/topic/hot',
    method: 'get'
  })
}

// 话题列表
export function getList (data) {
  return request({
    url: '/topic/list',
    method: 'get',
    params: data
  })
}
// 我参与的话题列表
export function getJoinList (data) {
  return request({
    url: '/topic/participation',
    method: 'get',
    params: data
  })
}

// 话题投票列表
export function getVote (topicId) {
  return request({
    url: `/topic/vote/get/${topicId}`,
    method: 'get'
  })
}

// 话题投票
export function setVote (voteId, ids) {
  let params = ''
  ids.forEach((id, idx) => {
    if (idx === 0) {
      params += `ids=${id}`
    } else {
      params += `&ids=${id}`
    }
  })
  return request({
    url: `/topic/vote/${voteId}?${params}`,
    method: 'post'
  })
}

// 添加话题
export function addTopic (data) {
  return request({
    url: `/topic/save`,
    method: 'post',
    data
  })
}
// 编辑话题
export function editTopic (data) {
  return request({
    url: `/topic/update`,
    method: 'put',
    data
  })
}

// 删除话题
export function delTopic (id) {
  return request({
    url: `/topic/delete/${id}`,
    method: 'delete'
  })
}

// 话题评论列表
export function getComment (data) {
  return request({
    url: '/comment/topic/list',
    method: 'get',
    params: data
  })
}
// 话题二级评论列表
export function getChildComment (data) {
  return request({
    url: `/comment/topic/list/reload/${data.commentId}`,
    method: 'get',
    params: data
  })
}
// 添加话题评论
export function addComment (data) {
  return request({
    url: '/comment/topic',
    method: 'post',
    data
  })
}

// 点赞
export function like (topicId, id) {
  return request({
    url: `/comment/topic/like/${topicId}/${id}`,
    method: 'post'
  })
}

// 取消点赞
export function dislike (id) {
  return request({
    url: `/comment/topic/disLike/${id}`,
    method: 'post'
  })
}
